var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgXX = function SvgXX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M5.6 15A13 13 0 0 0 9 16v.8l-1.5-.4-2-.7.1-.4z",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    d: "M1.9 7.9a8 8 0 0 0 3.7 3.7m-3.2 1.7a11 11 0 0 1 3.5-7.5",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.7 7.5q.7 2 .9 4v.4l.3-.1 2-1h.1l.2.7q-1 .8-2.4 1.1l-.2.1v.2l-.1 2.2-.1.6v.1l-1 .3.2-.5.2-2.4v-.3h-.3q-1.6.3-3 0v-.7h3.1l.2-.1v-.2q-.2-2.1-.9-4.1z",
    id: "d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.6 12.1",
    id: "e"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.6,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 1.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    strokeWidth: 0.8,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    strokeWidth: 0.8,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.7,
    stroke: "white",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.7,
    stroke: "white",
    strokeWidth: 3.4
  }))));
};
var Memo = /*#__PURE__*/memo(SvgXX);
export default Memo;